if (!customElements.get('td-accordion-group')) {
  class TDAccordionGroup extends HTMLElement {
    static selectors = {
      details: '[data-td-accordion-details]',
      summary: 'summary',
    };

    static mobileQuery = '(max-width: 749px)';

    constructor() {
      super();
      this.detailsItems = [];
      this.handleToggle = this.handleToggle.bind(this);
    }

    get exclusive() {
      return this.hasAttribute('data-td-accordion-exclusive');
    }

    connectedCallback() {
      this.detailsItems = [...this.querySelectorAll(TDAccordionGroup.selectors.details)];

      this.detailsItems.forEach((details) => {
        details.addEventListener('toggle', this.handleToggle);
        this.syncExpandedState(details);
      });
    }

    disconnectedCallback() {
      this.detailsItems.forEach((details) => details.removeEventListener('toggle', this.handleToggle));
      this.detailsItems = [];
    }

    handleToggle(event) {
      const details = event.target;
      if (!(details instanceof HTMLDetailsElement)) return;

      this.syncExpandedState(details);

      if (!details.open || !this.shouldCloseOthers(details)) return;

      this.detailsItems.forEach((other) => {
        if (other !== details && other.open) {
          other.open = false;
        }
      });
    }

    shouldCloseOthers(details) {
      if (!this.exclusive) return false;

      const accordion = details.closest('accordion-custom');
      if (!(accordion instanceof HTMLElement)) return true;

      const isMobile = window.matchMedia(TDAccordionGroup.mobileQuery).matches;

      if (accordion.dataset.disableOnDesktop === 'true' && !isMobile) return false;
      if (accordion.dataset.disableOnMobile === 'true' && isMobile) return false;

      return true;
    }

    syncExpandedState(details) {
      details.querySelector(TDAccordionGroup.selectors.summary)?.setAttribute(
        'aria-expanded',
        String(details.open)
      );
    }
  }

  customElements.define('td-accordion-group', TDAccordionGroup);
}
